import $ from 'jquery';
import { debounce } from '../utils/functions';

const callList = listEl => {
    const filter = {
        page: 1,
        search: '',
        timeSpan: '',
        regions: [],
        areas: [],
        applicants: [],
    };

    bindCallFilter(listEl, filter);
    bindCallLoadMore(listEl, filter);
};

const reRenderList = async (element, filter, loadMore = false) => {
    const data = await getCalls(filter);
    if (loadMore) {
        element.find('.call-list__grid').append(data.html);
    } else {
        element.find('.call-list__grid').html(data.html);
    }
    element.find('.call-list__show-more').html(data.loadMore);
};

const bindCallFilter = (element, filter) => {
    element.find('.radio-list').on('radiolist:changed', function () {
        filter.page = 1;
        filter.timeSpan = element.find("input[name='call-timespan']:checked").val();
        reRenderList(element, filter);
    });

    element.on(
        'input',
        "input[name='call-filter-search']",
        debounce(function () {
            filter.search = $(this).val();
            filter.timeSpan = element.find("input[name='call-timespan']:checked").val();
            toggleResetButton(element, filter);
            reRenderList(element, filter);
        })
    );

    element.on('change', '.checkbox__region', function () {
        filter.page = 1;

        const $thisEl = $(this);
        let regionId = parseInt($thisEl.attr('id').split('_')[1]);
        if ($thisEl.is(':checked')) {
            filter.regions.push(regionId);
        } else {
            let index = filter.regions.indexOf(regionId);
            filter.regions.splice(index, 1);
        }

        toggleResetButton(element, filter);
        reRenderList(element, filter);
    });

    element.on('change', '.checkbox__area', function () {
        filter.page = 1;

        const $thisEl = $(this);
        let areaId = parseInt($thisEl.attr('id').split('_')[1]);
        if ($thisEl.is(':checked')) {
            filter.areas.push(areaId);
        } else {
            let index = filter.areas.indexOf(areaId);
            filter.areas.splice(index, 1);
        }

        toggleResetButton(element, filter);
        reRenderList(element, filter);
    });

    element.on(
        'input',
        'input[name="call-filter-applicants-search"]',
        debounce(function () {
            const keyWord = String($(this).val()).replace(/\s/g, '').toLowerCase();
            toggleResetButton(element, filter);

            if (keyWord) {
                const $checkboxes = element.find('.checkbox__applicant');
                const matchingKeyWords = [];

                $checkboxes.each(function () {
                    const kw = $(this).data('keyword');
                    kw.includes(keyWord) && matchingKeyWords.push(kw);
                });

                $checkboxes.parent().hide(0, () => {
                    if (matchingKeyWords.length) {
                        matchingKeyWords.forEach(kw => {
                            element
                                .find(`.checkbox__applicant[data-keyword='${kw}']`)
                                .parent()
                                .show(0);
                        });
                    }
                });
            } else {
                element.find('.checkbox__applicant').parent().removeAttr('style');
            }
        })
    );

    element.on('change', '.checkbox__applicant', function () {
        filter.page = 1;

        const $thisEl = $(this);
        let applicantId = parseInt($thisEl.attr('id').split('_')[1]);
        if ($thisEl.is(':checked')) {
            filter.applicants.push(applicantId);
        } else {
            let index = filter.applicants.indexOf(applicantId);
            filter.applicants.splice(index, 1);
        }

        toggleResetButton(element, filter);
        reRenderList(element, filter);
    });

    element.on('click', '.call-list__filter-trigger', () => openFilter(element));
    element.on('click', '.call-filter__close, .call-filter__confirm, .call-filter__reset', () =>
        closeFilter(element)
    );

    element.on('click', '.call-filter__reset', () => {
        filter.page = 1;
        filter.regions = [];
        filter.areas = [];
        filter.applicants = [];

        element
            .find(
                '.checkbox__region:checked, .checkbox__area:checked, .checkbox__applicant:checked'
            )
            .prop('checked', false);
        element
            .find(
                'input[name="call-filter-applicants-search"], input[name="call-filter-search"]'
            )
            .val('')
            .trigger('input');

        // element.find('.accordion__toggle--active').trigger('click');

        toggleResetButton(element, filter);
        reRenderList(element, filter);
    });
};

const toggleResetButton = (element, filter) => {
    const $reset = element.find('.call-filter__reset');

    if (
        filter.regions.length ||
        filter.areas.length ||
        filter.applicants.length ||
        element.find('input[name="call-filter-applicants-search"]').val() ||
        element.find('input[name="call-filter-search"]').val()
    ) {
        $reset.show(300);
    } else {
        $reset.hide(300);
    }
};
const openFilter = element => element.find('.call-filter').addClass('active');
const closeFilter = element => element.find('.call-filter').removeClass('active');

const bindCallLoadMore = (element, filter) => {
    element.on('click', '.call-list__show-more-button', function () {
        filter.page++;
        reRenderList(element, filter, true);
    })
}

const getCalls = async filter => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/opst/v1/call/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export const reloadScriptCallList = () => {
    const $list = $('.call-list');

    if ($list.length > 0) {
        $list.each(function () {
            callList($(this));
        });
    }
};
reloadScriptCallList();
